import { render, staticRenderFns } from "./previousTransactionsTable.vue?vue&type=template&id=08fcfac2&"
import script from "./previousTransactionsTable.vue?vue&type=script&lang=js&"
export * from "./previousTransactionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports